import { render, staticRenderFns } from "./SlickSlider.vue?vue&type=template&id=12b4a3ad&"
import script from "./SlickSlider.vue?vue&type=script&lang=js&"
export * from "./SlickSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports